import { requestCreator } from "../../common/actions/VisitApi";

export type CompanyMembershipSection = WtdModels.Partial<
  WtdModels.CompanyMembershipSection,
  "id" | "name" | "description" | "display_order"
>;

export type CompanyMembership = WtdModels.Partial<
  WtdModels.CompanyMembership,
  "id" | "display_order" | "featured_display_order" | "position",
  {
    section: WtdModels.Partial<WtdModels.CompanyMembershipSection, "id">;
  }
>;

export type UpdateMembershipSectionResponse = CompanyMembershipSection;

export type CreateMembershipSectionResponse = CompanyMembershipSection;

export type UpdateMembershipsInBatchResponse = CompanyMembership[];

/**
 * Create a request action to update membership_section
 */
export const requestToUpdateMembershipSection = requestCreator<
  CompanyMembershipSection,
  UpdateMembershipSectionResponse,
  Error
>(section => ({
  path: `/api/v2/company_membership_sections/${section.id}`,
  query: {
    fields: ["id", "name", "description", "display_order"].join(","),
    include: [].join(","),
  },
  method: "PUT",
  body: section,
}));

/**
 * Create a request action to create new membership_section
 */
export const requestToCreateMembershipSection = requestCreator<
  { section: CompanyMembershipSection; companyId: number },
  CreateMembershipSectionResponse,
  Error
>(({ section, companyId }) => ({
  path: "/api/v2/company_membership_sections",
  query: {
    fields: ["id", "name", "description", "display_order"].join(","),
    include: [].join(","),
  },
  method: "POST",
  body: {
    ...section,
    company_id: companyId,
  },
}));

/**
 * Create a request action to delete membership_section
 */
export const requestToDeleteMembershipSection = requestCreator<number, undefined, Error>(id => ({
  path: `/api/v2/company_membership_sections/${id}`,
  method: "DELETE",
}));

/**
 * Create a request action to update memberships in batch
 */
export const requestToUpdateMembershipsInBatch = requestCreator<
  CompanyMembership[],
  UpdateMembershipsInBatchResponse,
  Error
>(memberships => {
  return {
    path: `/api/v2/company_memberships/batch_update`,
    method: "PATCH",
    // TODO(KentoMoriwaki): Allow to override query params by arguments or extending
    query: {
      fields: ["id", "display_order", "featured_display_order", "section.id"].join(","),
      include: ["section"].join(","),
    },
    body: {
      company_memberships: memberships.map(membership => {
        // Mapping associated entity to "_id" format
        return {
          ...membership,
          company_membership_section_id: membership.section ? membership.section.id : null,
        };
      }),
    },
  };
});



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/api/index.ts